// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
define(['react', 'react-dom', 'lodash', '/util/etask.js', '/util/ajax.js',
    '/util/url.js', '/util/country.js', '/www/util/pub/pure_component.js'],
    (React, ReactDOM, _, etask, ajax, zurl, zcountry, Pure_component)=>{

const Index = ()=>
    <div className="page">
      <Head/>
      <Body/>
    </div>;

const Head = ()=>
    <div className="head">
      <div className="logo"/>
    </div>;

class Body extends Pure_component {
    constructor(props){
        super(props);
        this.state = {};
    }
    UNSAFE_componentWillMount(){
        const _this = this;
        etask(function*(){
            const res = yield ajax.json({url: '/myip.json'});
            _this.setState({res});
        });
    }
    render(){
        return (
            <div className="body">
              <div className="content_wrapper">
                {this.state.res ?
                  <Content res={this.state.res}/> : <Loader/>}
              </div>
            </div>
        );
    }
}

const Field = props=>{
    let icon = '';
    if (props.icon_class)
        icon = <div className={'flag '+props.icon_class}/>;
    return (
        <div className="metric">
          <div className="title">{props.title}</div>
          <div className={'value'+(icon?' f19 '+props.icon_class:'')}>
            {icon} {props.value||'-'}
          </div>
        </div>
    );
};

const Content = props=>
    <div className="content">
      <Content_text res={props.res}/>
      <Banners/>
    </div>;

const Content_text = props=>{
    const ip = _.get(props, 'res.ip');
    const postal_code = _.get(props, 'res.geo.postal_code');
    const latitude = _.get(props, 'res.geo.latitude');
    const longitude = _.get(props, 'res.geo.longitude');
    const city = _.get(props, 'res.geo.city');
    const tz = _.get(props, 'res.geo.tz');
    const asn = _.get(props, 'res.asn.asnum');
    const org = _.get(props, 'res.asn.org_name');
    const country_code = _.get(props, 'res.country');
    const country_name = zcountry.list[country_code];
    return (
        <div className="content_text">
          <div className="ip_wrapper">
            <div className="label">Your IP</div>
            <div className="ip">{ip}</div>
          </div>
          <div className="columns">
            <div className="column">
              <div className="metrics">
                <Field title="Country" value={country_name}
                  icon_class={country_code.toLowerCase()}/>
                <Field title="ASN" value={asn}/>
                <Field title="Postal Code" value={postal_code}/>
                <Field title="Latitude" value={latitude}/>
              </div>
            </div>
            <div className="column">
              <div className="metrics">
                <Field title="City & Region" value={city}/>
                <Field title="Org. Name" value={org}/>
                <Field title="Time Zone" value={tz}/>
                <Field title="Longitude" value={longitude}/>
              </div>
            </div>
          </div>
          <div className="user_agent column">
            <Field title="User agent" value={navigator.userAgent}/>
          </div>
        </div>
    );
};

const Loader = ()=><div className="loader">Loading...</div>;

const Banners = ()=>{
    return (
        <div className="banners">
          <a href="https://brightdata.grsm.io/whatsmyippro">
            <img alt="Try Bright Data now"
              src="/www/whatismyip/pub/img/cta_brd.png"/>
          </a>
          <a href="https://hola.org/get_hola?a_aid=6107d4a0ac96b">
            <img alt="Change your IP"
              src="/www/whatismyip/pub/img/cta_hola.png"/>
          </a>
        </div>
    );
};

const E = {};

E.init = ()=>{
    ReactDOM.render(<Index/>, document.getElementById('root')); };

return E;
});
